import React from 'react';
import MinimizedDraftEntryButton from 'views/dossiers/components/MinimizedDraftEntryButton';

export interface MinimizedDraftButtonProps {
  onClick: () => void;
}

export default function MinimizedDraftButton({
  onClick,
}: MinimizedDraftButtonProps) {
  return (
    <MinimizedDraftEntryButton
      onClick={onClick}
      labelKey="ajout_dossier:minimized_entry"
    />
  );
}
